/**
 * <cart-page-component> — page panier (/cart).
 *
 * Écoute `CartUpdateEvent` (dispatché par `<cart-items-component>` après
 * un POST /cart/change.js) et re-render la section parent via la Section
 * Rendering API. Cela rafraîchit la liste des items, les totaux et le
 * récapitulatif sans rechargement de page complet.
 *
 * Pattern miroir de `<cart-drawer-component>`, simplifié : pas de
 * <dialog> à préserver ici, on remplace la section entière.
 */

import { sectionRenderer } from "@theme/section-renderer";
import { CartUpdateEvent } from "@theme/events";

class CartPageComponent extends HTMLElement {
  connectedCallback() {
    this.__onCartUpdate = () => this.#refresh();
    document.addEventListener(CartUpdateEvent.eventName, this.__onCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener(CartUpdateEvent.eventName, this.__onCartUpdate);
  }

  /** Retourne l'id de la <section class="shopify-section"> parente. */
  get sectionId() {
    const el = this.closest(".shopify-section");
    if (!el) return null;
    return el.id.replace(/^shopify-section-/, "");
  }

  async #refresh() {
    const id = this.sectionId;
    if (!id) return;
    try {
      await sectionRenderer.renderSection(id);
    } catch (err) {
      console.error("[cart-page] refresh failed:", err);
    }
  }
}

if (!customElements.get("cart-page-component")) {
  customElements.define("cart-page-component", CartPageComponent);
}
